import { Link } from "react-router-dom";

const Page404 = () => {
    return (
        <div style={{
            textAlign: "center",
            marginTop: "15%",
            // color: "#8c8c8c"
        }}>
            <p style={{ fontSize: "44px" }}>404 Error</p>
            <p style={{ fontSize: "18px" }}>This page doesn't exist, <Link to="/login">Back to Login?</Link></p>
        </div>
    )
}

export default Page404;